<script setup lang="ts">
export type Props = {
  wrapOn?: 'mobile' | 'tablet';
};

defineProps<Props>();
</script>

<template>
  <section class="hero" :class="{ 'hero--wrap-on-tablet': wrapOn === 'tablet' }">
    <div
      class="hero__container"
      :class="{ 'hero__container--wrap-on-tablet': wrapOn === 'tablet' }"
    >
      <div class="hero__left" :class="{ 'hero__left--wrap-on-tablet': wrapOn === 'tablet' }">
        <slot name="left"></slot>
      </div>
      <div class="hero__right" :class="{ 'hero__left--wrap-on-tablet': wrapOn === 'tablet' }">
        <slot name="right"></slot>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
@use '../assets/styles/_globals.scss' as g;

.hero {
  display: flex;
  padding: var(--hero-padding, 6rem);
  justify-content: center;

  @media (max-width: g.$desktop-breakpoint) {
    padding: 4rem;
  }

  @media (max-width: g.$tablet-breakpoint) {
    &--wrap-on-tablet {
      padding: 2rem;
    }
  }

  @media (max-width: g.$mobile-breakpoint) {
    padding: 2rem;
  }

  &__container {
    display: flex;
    flex-direction: row;
    gap: 5rem;
    width: 100%;
    max-width: var(--hero-container-max-width, 100%);

    @media (max-width: g.$tablet-breakpoint) {
      gap: 3rem;

      &--wrap-on-tablet {
        align-items: center;
        flex-direction: column;
      }
    }

    @media (max-width: g.$mobile-breakpoint) {
      align-items: center;
      flex-direction: column;
    }
  }

  &__left {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: var(--hero-left-width, 50%);

    @media (max-width: g.$tablet-breakpoint) {
      &--wrap-on-tablet {
        width: unset !important;
      }
    }

    @media (max-width: g.$mobile-breakpoint) {
      width: unset;
    }
  }

  &__right {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: var(--hero-right-width, 50%);

    @media (max-width: g.$tablet-breakpoint) {
      &--wrap-on-tablet {
        width: unset !important;
      }
    }

    @media (max-width: g.$mobile-breakpoint) {
      width: unset;
    }
  }
}
</style>
